export const FORM_SET = "FORM_SET";
export const FORM_UPDATE = "FORM_UPDATE";

export const APP_SNACKBAR_ADD = "APP_SNACKBAR_ADD";
export const APP_SNACKBAR_REMOVE = "APP_SNACKBAR_REMOVE";

export const USER_EMAIL_SET = "USER_EMAIL_SET";
